import * as actionLinks from './action-links/action-links';
import * as ajaxProgress from './ajax-progress/ajax-progress';
import * as breadcrumb from './breadcrumb/breadcrumb';
import * as button from './button/button';
import * as comments from './comments/comments';
import * as containerInline from './container-inline/container-inline';
import * as contextual from './contextual/contextual';
import * as details from './details/details';
import * as dialogPositionSide from './dialog-position-side/dialog-position-side';
import * as elements from './elements/elements';
import * as euCookieCompliance from './eu-cookie-compliance/eu-cookie-compliance';
import * as exposedFilters from './exposed-filters/exposed-filters';
import * as feedIcon from './feed-icon/feed-icon';
import * as formApi from './form-api/form-api';
import * as glossaryView from './glossary-view/glossary-view';
import * as helpIcon from './help-icon/help-icon';
import * as inlineForm from './inline-form/inline-form';
import * as itemList from './item-list/item-list';
import * as layoutBuilder from './layout-builder/layout-builder';
import * as links from './links/links';
import * as menuMain from './menu-main/menu-main';
import * as messages from './messages/messages';
import * as moreLink from './more-link/more-link';
import * as newsletterSubscribe from './newsletter-subscribe/newsletter-subscribe';
import * as onomasticon from './onomasticon/onomasticon';
import * as pager from './pager/pager';
import * as progress from './progress/progress';
import * as searchForm from './search-form/search-form';
import * as searchResults from './search-results/search-results';
import * as tableAdmin from './table-admin/table-admin';
import * as tabs from './tabs/tabs';
import * as toolbarAdministration from './toolbar-administration/toolbar-administration';
import * as verticalTabs from './vertical-tabs/vertical-tabs';
import * as visuallyHidden from './visually-hidden/visually-hidden';
import * as wysiwygEdition from './wysiwyg-edition/wysiwyg-edition';

export default {
  actionLinks,
  ajaxProgress,
  breadcrumb,
  button,
  comments,
  containerInline,
  contextual,
  details,
  dialogPositionSide,
  elements,
  euCookieCompliance,
  exposedFilters,
  feedIcon,
  formApi,
  glossaryView,
  helpIcon,
  inlineForm,
  itemList,
  layoutBuilder,
  links,
  menuMain,
  messages,
  moreLink,
  onomasticon,
  newsletterSubscribe,
  pager,
  progress,
  searchForm,
  searchResults,
  tableAdmin,
  tabs,
  toolbarAdministration,
  verticalTabs,
  visuallyHidden,
  wysiwygEdition,
}
